import React from 'react';
import Select from 'react-select';
import { useTranslation } from 'react-i18next';

interface LanguageOption {
  value: string;
  label: string;
  icon: string;
}

const languageOptions = [
  { value: 'vi', label: '🇻🇳 Tiếng Việt', icon: '/assets/images/vi-icon.png' },
  { value: 'en', label: '🇺🇸 English', icon: '/assets/images/en-icon.png' },
];

const customStyles = {
  control: (provided: any, state: any) => ({
    ...provided,
    minWidth: 100,
    boxShadow: 'none',
    border: 'none',
    backgroundColor: 'white', // tùy chỉnh nếu cần
  }),
};

const SwitchLanguage: React.FC = () => {
  const { i18n } = useTranslation();

  const currentLang = languageOptions.find((opt) => opt.value === i18n.language) || languageOptions[0];
  const handleChange = (selected: any) => {
    i18n.changeLanguage(selected.value);
    localStorage.setItem('language', selected.value);
  };

  return (
    <Select
      value={currentLang}
      onChange={handleChange}
      options={languageOptions}
      styles={customStyles}
      isSearchable={false}
      formatOptionLabel={(e: LanguageOption) => (
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
          <img src={e.icon} alt={e.label} width="20" height="14" />
          <span>{e.label}</span>
        </div>
      )}
    />
  );
};

export default SwitchLanguage;